import React, {Component} from 'react'
import OrderItemPage from './OrderItemPage'
import queryString from 'query-string'
import '../styles/index.scss'

class OrderItemPageContainer extends Component {
    render() {
        const query = queryString.parse(this.props.location.search)
        const template = query.template || ''

        return (
            <div className='OrderItemPageContainer Huge'>
                <div className='container-fluid min-vh-100 bg-white shadow-sm'>
                    <div className='row'>
                        <div className='col'>
                            <OrderItemPage currentTemplate={template}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default OrderItemPageContainer
